import { useState, useEffect } from 'react';
import { db } from '@/lib/firebase';
import { doc, getDoc } from 'firebase/firestore';
import ConsultingHero from './components/ConsultingHero';
import ConsultingServices from './components/ConsultingServices';
import ConsultingWhoFor from './components/ConsultingWhoFor';
import ConsultingCTA from './components/ConsultingCTA';
import SEO from '@/components/feature/SEO';

const BusinessConsultingPage = () => {
  const [consultingUrl, setConsultingUrl] = useState('/contact');

  useEffect(() => {
    const fetchSettings = async () => {
      try {
        const settingsRef = doc(db, 'settings', 'general');
        const docSnap = await getDoc(settingsRef);
        if (docSnap.exists() && docSnap.data().consultingUrl) {
          setConsultingUrl(docSnap.data().consultingUrl);
        }
      } catch (error) {
        console.error('Error fetching consultingUrl:', error);
      }
    };
    fetchSettings();
  }, []);

  return (
    <main className="bg-[#030006] min-h-screen">
      <SEO 
        title="Consultoría de Negocios | Sbdigisolutions" 
        description="Servicios de consultoría 1 a 1 para hacer crecer tu marca y establecer estrategias sólidas de negocio." 
      />
      <ConsultingHero consultingUrl={consultingUrl} />
      <ConsultingServices consultingUrl={consultingUrl} />
      <ConsultingWhoFor />
      <ConsultingCTA consultingUrl={consultingUrl} />
    </main>
  );
};

export default BusinessConsultingPage;
